<template>
    <template v-if="value">
        <div :style="margin" @click.stop="setUpdate()" class="row py-1 drag-el" :class="{'sameElement': sameElement }">
            <div class="col-2">
                <div class="rowIcon">
                    <span>{{ icon }}</span>
                </div>
            </div>
            <div class="col-4">
                <span>{{ $t("componentRaw." + value.component) }}</span>
            </div>
            <div class="col-1">
                <button v-if="position && !up"><icon icon="PlayerFirst"/></button>
            </div>
            <div class="col-1">
                <button v-if="position" @click="$emit('insert')"><icon icon="PlayerLast"/></button>
            </div>
            <div class="col-1">
                <button v-if="last != position" @click="$emit('move', position, position + 1)"><icon icon="ArrowDown"/></button>
            </div>
            <div class="col-1">
                <button v-if="position" @click="$emit('move', position, position - 1)"><icon icon="ArrowUp"/></button>
            </div>
            <div class="col-1">
                <button @click="$emit('delete')">X</button>
            </div>
        </div>
        <CreateComponent v-model="parentValue" :position="position"/>
        <Blocks v-model="value" :tabs="tabs + 1" :up="false"/>
    </template>
</template>


<script>
import { defineAsyncComponent } from 'vue';
const Blocks = defineAsyncComponent(() => import('@/components/calculations/Blocks.vue'));
import CreateComponent from '@/components/calculations/CreateComponent.vue';

export default {
    components: {
        Blocks,
        CreateComponent
    },
    emits: ['move', 'insert', 'delete'],
    props: {
        modelValue: {},
        tabs: {
            type: Number,
            required: false,
            default: 0
        },
        position: {
            type: Number,
            required: false,
            default: 0
        },
        last: {
            type: Number,
            required: false,
            default: 0
        },
        up: {
            type: Boolean,
            required: false,
            default: false
        },
        parent: {
            type: Object,
            required: false,
            default: false
        },
    },
    emits: ['update:modelValue', 'update:parent'],
    data() {
        return {}
    },
    computed: {
        margin: function () {
            return "margin-left: " + (15 * this.tabs) + "px"
        },
        value: {
            get() {
                return this.modelValue
            },
            set(value) {
                this.$emit('update:modelValue', value)
            }
        },
        parentValue: {
            get() {
                return this.parent
            },
            set(value) {
                this.$emit('update:parent', value)
            }
        },
        icon: function () {
            if (this.value.component == 'H1') {
                return 'H1'
            }
            if (this.value.component == 'H2') {
                return 'H1'
            }
            if (this.value.component == 'H3') {
                return 'H1'
            }
            if (this.value.component == 'Input') {
                return 'I'
            }
            if (this.value.component == 'Multiselect') {
                return 'M'
            }
            if (this.value.component == 'Table') {
                return 'T'
            }
            if (this.value.component == 'Row') {
                return 'R'
            }
            if (this.value.component == 'Column') {
                return 'C'
            }
            if (this.value.component == 'Link') {
                return 'L'
            }
            if (this.value.component == 'Paragraph') {
                return 'P'
            }
            if (this.value.component == 'Link') {
                return 'L'
            }
            if (this.value.component == 'Image') {
                return 'IMG'
            }
            if (this.value.component == 'Div') {
                return 'D'
            }
            if (this.value.component == 'Block') {
                return 'B'
            }
            if (this.value.component == 'ProductRow') {
                return 'PR'
            }
            if (this.value.component == 'Select') {
                return 'S'
            }
        },
        sameElement: function () {
            if (!this.value || !this.$store.getters.componentData){
                return false;
            }
            return this.value.id == this.$store.getters.componentData.id
        }
    },
    methods: {
        update: function (data) {
            this.value = data;
        },
        setUpdate: function () {
            this.$store.commit("updateComponent", {
                function: this.update,
                data: this.value
            });
        }
    }
}
</script>

<style lang="scss">
</style>